import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  get(key: string): any {
    const val = sessionStorage.getItem(key);
    if (!val) return null;
    const trimmed = val.trim();
    // Only parse likely JSON payloads (objects/arrays). This avoids turning "true"/"false"/"123" into non-strings.
    if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) return val;
    try { return JSON.parse(trimmed); } catch { return val; }
  }

  set(key: string, value: any): void {
    sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }
}
